"use client";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBannerStore } from "../../store/bannerStore";

type BannerStaticProps = {
  className?: string;
  children?: React.ReactNode;
  showAll?: boolean;
  blur?: boolean; // 🔹 tambahan prop untuk kontrol efek blur
};

export default function BannerStatic({
  className = "",
  children,
  showAll = true,
  blur = false, // 🔹 default: tidak blur
}: BannerStaticProps) {
  const { banners, fetchBanners } = useBannerStore();
    const location = useLocation();
  const currentLang = location.pathname.startsWith("/id") ? "id" : "en";

  useEffect(() => {
    fetchBanners(currentLang);
  }, [fetchBanners, currentLang]);

  const visibleBanners = showAll ? banners : banners.slice(0, 1);

  return (
    <section
  className={`relative w-full h-[95vh] md:h-[80vh] overflow-hidden ${className}`}
>
      {visibleBanners.map((banner) => (
        <div
          key={banner.id}
          className="relative w-full h-full bg-cover bg-center"
        >
          {/* Background desktop */}
          <div
            className="absolute inset-0 bg-center bg-cover hidden md:block"
            style={{ backgroundImage: `url(${banner.image_desktop})` }}
          />
          {/* Background mobile */}
          <div
            className="absolute inset-0 bg-center bg-cover md:hidden"
            style={{ backgroundImage: `url(${banner.image_mobile})` }}
          />

          {/* Overlay */}
          <div
            className={`absolute inset-0 bg-black/40 transition-all duration-500 ${
              blur ? "backdrop-blur-md" : ""
            }`}
          />

          {/* Konten */}
          <div className="relative z-10 h-full flex flex-col justify-center text-white container-banner sm:px-10 lg:px-20 xl:px-28 max-w-[1920px] mx-auto">
            {children}
          </div>
        </div>
      ))}
    </section>
  );
}
